import React from "react";
import { Link } from "react-router-dom";

const SettingsPage = () => {
  return (
    <div className="bg-gray-100 min-h-screen p-8">
      <div className="max-w-4xl mx-auto bg-white shadow-md rounded-md p-6">
        <h1 className="text-2xl font-bold mb-6">Settings</h1>

        {/* Personal Information Section */}
        <div className="mb-8">
          <h2 className="text-lg font-semibold mb-4">Personal Information</h2>
          <div className="grid grid-cols-2 md:grid-cols-4 gap-4">
            <Link to="/upload-picture" className="text-blue-600 hover:underline">Upload picture</Link>
            <Link to="/edit-profile" className="text-blue-600 hover:underline">Edit profile</Link>
            <Link to="/delete-account" className="text-blue-600 hover:underline">Delete account</Link>
          </div>
        </div>

        {/* Security Information Section */}
        <div className="mb-8">
          <h2 className="text-lg font-semibold mb-4">Security Information</h2>
          <div className="grid grid-cols-2 md:grid-cols-4 gap-4">
            <Link to="/change-email" className="text-blue-600 hover:underline">Change email address</Link>
            <Link to="/change-password" className="text-blue-600 hover:underline">Change password</Link>
            <Link to="/set-security-question" className="text-blue-600 hover:underline">Set security question</Link>
            <Link to="/change-phone-number" className="text-blue-600 hover:underline">Change phone number</Link>
          </div>
        </div>

        {/* Activate Email Notifications Section */}
        <div className="mb-8">
          <h2 className="text-lg font-semibold mb-4">Activate email notifications</h2>
          <Link to="/activate-email" className="text-blue-600 hover:underline">Activate</Link>
        </div>

        {/* Social Media Accounts Section */}
        <div className="mb-8">
          <h2 className="text-lg font-semibold mb-4">Social media accounts</h2>
          <div className="flex items-center gap-4">
            <div className="flex items-center gap-2">
              <img
                src="https://img.icons8.com/color/48/facebook-messenger--v1.png"
                alt="Messenger Icon"
                className="w-6 h-6"
              />
              <span>Messenger</span>
            </div>
            <Link to="/link-messenger" className="text-blue-600 hover:underline">Link</Link>
          </div>
        </div>
      </div>
    </div>
  );
};

export default SettingsPage;
